import Backbone from 'backbone';
import ChartModel from '@/data/models/chart';

export default Backbone.Collection.extend({
  model: ChartModel
})
